import type React from 'react'

import css from './TemplateBadge.module.css'

// Marks the open project as a template, so an edit is never mistaken for work
// on a real project. The shared Badge has no template variant and its label is
// derived from a plan id, so this one carries its own.
export const TemplateBadge: React.FC = () => (
  <div className={css.badge}>Template</div>
)
